import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
// import axios from 'axios';
import QRQinectAPI from '../QRQinectAPI';
import Switch from 'react-switch';

class MyCodes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasBusinessAccount: false,
            Buyer: { Name: 'Name' },
            ShowSendText: false,
            Codes: [],
            ViewableCodes: [],
            ShowComponent: false,
            qrNotifyArray: [],
            Switch: { height: 21, width: 48, primaryColor: "#027473", secondaryColor: "#AFD8C9" },
            loading: true,
            ShowAllClickStats: false,
            StatsLoading: false,
            StatsProcessing: 0
        };
        this.monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        this.qrNotifyArray = [];
        this.qrStatsArray = [];
        this.Buyer = { Name: 'Name' };
        // used when renaming a QRCode
        this.newName = "";
        // used to search/filter
        this.searchTerm = "";
        // current sort option
        this.sortedBy = "";
        // for sending SMS, we need to know how to format the link.
        // we'll do that here for now.
        this.SMSSeparator = "?";
        this.requirePhone = false;
        let ua = navigator.userAgent;
        if (ua.match(/iPad/i) || ua.match(/iPhone/i)) {
            this.SMSSeparator = "&";
            let uaIndex = ua.indexOf('OS ');
            if (uaIndex > -1) {
                let version = ua.substr(uaIndex + 3, 3).replace('_', '.');
                if (version <= 8) {
                    this.SMSSeparator = ";";
                }
            }
        } else if (ua.match(/OS X/i)) {
            this.SMSSeparator = "&";
            this.requirePhone = true; // iMessage doesn't like not having a phone number
        }
    }
    componentDidMount() {
        this.reload()
    }
    updateCodeStats = (objectIndex, newValue) => {
        let stateCopy = Object.assign({}, this.state);
        stateCopy['Codes'][objectIndex] = newValue;
        this.setState(stateCopy);
    }
    updateBuyerStats = () => {
        // need to update the overall stats by adding the stats from this QRCode
        let stateCopy = Object.assign({}, this.state);
        let buyerStatsCopy = Object.assign({}, this.state.BuyerStats);
        let numScans = buyerStatsCopy.NumScans;
        let numClicks = buyerStatsCopy.NumClicks;
        let numMessages = buyerStatsCopy.NumMessages;
        let numDownloads = buyerStatsCopy.NumDownloads;
        let numCodesWithScans = buyerStatsCopy.NumCodesWithScans;
        let numCodesWithClicks = buyerStatsCopy.NumCodesWithClicks;
        let numCodesWithMessages = buyerStatsCopy.NumCodesWithMessages;
        let numCodesWithDownloads = buyerStatsCopy.NumCodesWithDownloads;
        let numCTAClicks = buyerStatsCopy.NumCTAClicks;
        let numFacebookShareClicks = buyerStatsCopy.NumFacebookShareClicks;
        let numTwitterShareClicks = buyerStatsCopy.NumTwitterShareClicks;
        let numLinkedInShareClicks = buyerStatsCopy.NumLinkedInShareClicks;
        let numEmailShareClicks = buyerStatsCopy.NumEmailShareClicks;
        let numFacebookLinkClicks = buyerStatsCopy.NumFacebookLinkClicks;
        let numTwitterLinkClicks = buyerStatsCopy.NumTwitterLinkClicks;
        let numLinkedInLinkClicks = buyerStatsCopy.NumLinkedInLinkClicks;
        let numInstagramLinkClicks = buyerStatsCopy.NumInstagramLinkClicks;
        let numEmailLinkClicks = buyerStatsCopy.NumEmailLinkClicks;
        let numPinterestLinkClicks = buyerStatsCopy.NumPinterestLinkClicks;
        let numWebLinkClicks = buyerStatsCopy.NumWebLinkClicks;
        let numYouTubeLinkClicks = buyerStatsCopy.NumYouTubeLinkClicks;
        for (let i = 0; i < this.state.Codes.length; i++) {
            let obj = this.state.Codes[i];

            if (obj.IncludeInStatistics) {
                numScans += obj.Scans;
                if (obj.Scans > 0) {
                    numCodesWithScans++;
                }
                numClicks += obj.Clicks
                if (obj.Clicks > 0) {
                    numCodesWithClicks++;
                }
                numMessages += obj.Messages
                if (obj.Messages > 0) {
                    numCodesWithMessages++;
                }
                numDownloads += obj.Downloads
                if (obj.Downloads > 0) {
                    numCodesWithDownloads++;
                }
                numCTAClicks += obj.CTAClicks;
                numFacebookShareClicks += obj.FacebookShareClicks;
                numTwitterShareClicks += obj.TwitterShareClicks;
                numLinkedInShareClicks += obj.LinkedInShareClicks;
                numEmailShareClicks += obj.EmailShareClicks;
                numFacebookLinkClicks += obj.FacebookLinkClicks;
                numTwitterLinkClicks += obj.TwitterLinkClicks;
                numLinkedInLinkClicks += obj.LinkedInLinkClicks;
                numInstagramLinkClicks += obj.InstagramLinkClicks;
                numEmailLinkClicks += obj.EmailLinkClicks;
                numPinterestLinkClicks += obj.PinterestLinkClicks;
                numWebLinkClicks += obj.WebLinkClicks;
                numYouTubeLinkClicks += obj.YouTubeLinkClicks;
            }
        }
        // set the buyerstats state value
        buyerStatsCopy.NumScans += numScans;
        buyerStatsCopy.NumClicks += numClicks;
        buyerStatsCopy.NumMessages += numMessages;
        buyerStatsCopy.NumDownloads += numDownloads;
        buyerStatsCopy.NumCodesWithScans += numCodesWithScans;
        buyerStatsCopy.NumCodesWithClicks += numCodesWithClicks;
        buyerStatsCopy.NumCodesWithMessages += numCodesWithMessages;
        buyerStatsCopy.NumCodesWithDownloads += numCodesWithDownloads;
        buyerStatsCopy.NumCTAClicks += numCTAClicks;
        buyerStatsCopy.NumFacebookShareClicks += numFacebookShareClicks;
        buyerStatsCopy.NumTwitterShareClicks += numTwitterShareClicks;
        buyerStatsCopy.NumLinkedInShareClicks += numLinkedInShareClicks;
        buyerStatsCopy.NumEmailShareClicks += numEmailShareClicks;
        buyerStatsCopy.NumFacebookLinkClicks += numFacebookLinkClicks;
        buyerStatsCopy.NumTwitterLinkClicks += numTwitterLinkClicks;
        buyerStatsCopy.NumLinkedInLinkClicks += numLinkedInLinkClicks;
        buyerStatsCopy.NumInstagramLinkClicks += numInstagramLinkClicks;
        buyerStatsCopy.NumEmailLinkClicks += numEmailLinkClicks;
        buyerStatsCopy.NumPinterestLinkClicks += numPinterestLinkClicks;
        buyerStatsCopy.NumWebLinkClicks += numWebLinkClicks;
        buyerStatsCopy.NumYouTubeLinkClicks += numYouTubeLinkClicks;

        stateCopy['BuyerStats'] = buyerStatsCopy;
        this.setState(stateCopy);

    }
    addQRtoBuyerStats = (obj) => {
        // need to update the overall stats by adding the stats from this QRCode
        let stateCopy = Object.assign({}, this.state);
        let buyerStatsCopy = Object.assign({}, this.state.BuyerStats);
        let numScans = 0;//buyerStatsCopy.NumScans;
        let numClicks = 0;//buyerStatsCopy.NumClicks;
        let numMessages = 0;//buyerStatsCopy.NumMessages;
        let numDownloads = 0;//buyerStatsCopy.NumDownloads;
        let numCodesWithScans = 0;//buyerStatsCopy.NumCodesWithScans;
        let numCodesWithClicks = 0;//buyerStatsCopy.NumCodesWithClicks;
        let numCodesWithMessages = 0;//buyerStatsCopy.NumCodesWithMessages;
        let numCodesWithDownloads = 0;//buyerStatsCopy.NumCodesWithDownloads;
        let numCTAClicks = 0;//buyerStatsCopy.NumCTAClicks;
        let numFacebookShareClicks = 0;//buyerStatsCopy.NumFacebookShareClicks;
        let numTwitterShareClicks = 0;//buyerStatsCopy.NumTwitterShareClicks;
        let numLinkedInShareClicks = 0;//buyerStatsCopy.NumLinkedInShareClicks;
        let numEmailShareClicks = 0;//buyerStatsCopy.NumEmailShareClicks;
        let numFacebookLinkClicks = 0;//buyerStatsCopy.NumFacebookLinkClicks;
        let numTwitterLinkClicks = 0;//buyerStatsCopy.NumTwitterLinkClicks;
        let numLinkedInLinkClicks = 0;//buyerStatsCopy.NumLinkedInLinkClicks;
        let numInstagramLinkClicks = 0;//buyerStatsCopy.NumInstagramLinkClicks;
        let numEmailLinkClicks = 0;//buyerStatsCopy.NumEmailLinkClicks;
        let numPinterestLinkClicks = 0;//buyerStatsCopy.NumPinterestLinkClicks;
        let numWebLinkClicks = 0;//buyerStatsCopy.NumWebLinkClicks;
        let numYouTubeLinkClicks = 0;//buyerStatsCopy.NumYouTubeLinkClicks;


        if (obj.IncludeInStatistics) {
            numScans += obj.Scans;
            if (obj.Scans > 0) {
                numCodesWithScans++;
            }
            numClicks += obj.Clicks
            if (obj.Clicks > 0) {
                numCodesWithClicks++;
            }
            numMessages += obj.Messages
            if (obj.Messages > 0) {
                numCodesWithMessages++;
            }
            numDownloads += obj.Downloads
            if (obj.Downloads > 0) {
                numCodesWithDownloads++;
            }
            numCTAClicks += obj.CTAClicks;
            numFacebookShareClicks += obj.FacebookShareClicks;
            numTwitterShareClicks += obj.TwitterShareClicks;
            numLinkedInShareClicks += obj.LinkedInShareClicks;
            numEmailShareClicks += obj.EmailShareClicks;
            numFacebookLinkClicks += obj.FacebookLinkClicks;
            numTwitterLinkClicks += obj.TwitterLinkClicks;
            numLinkedInLinkClicks += obj.LinkedInLinkClicks;
            numInstagramLinkClicks += obj.InstagramLinkClicks;
            numEmailLinkClicks += obj.EmailLinkClicks;
            numPinterestLinkClicks += obj.PinterestLinkClicks;
            numWebLinkClicks += obj.WebLinkClicks;
            numYouTubeLinkClicks += obj.YouTubeLinkClicks;
        }

        // set the buyerstats state value
        buyerStatsCopy.NumScans += numScans;
        buyerStatsCopy.NumClicks += numClicks;
        buyerStatsCopy.NumMessages += numMessages;
        buyerStatsCopy.NumDownloads += numDownloads;
        buyerStatsCopy.NumCodesWithScans += numCodesWithScans;
        buyerStatsCopy.NumCodesWithClicks += numCodesWithClicks;
        buyerStatsCopy.NumCodesWithMessages += numCodesWithMessages;
        buyerStatsCopy.NumCodesWithDownloads += numCodesWithDownloads;
        buyerStatsCopy.NumCTAClicks += numCTAClicks;
        buyerStatsCopy.NumFacebookShareClicks += numFacebookShareClicks;
        buyerStatsCopy.NumTwitterShareClicks += numTwitterShareClicks;
        buyerStatsCopy.NumLinkedInShareClicks += numLinkedInShareClicks;
        buyerStatsCopy.NumEmailShareClicks += numEmailShareClicks;
        buyerStatsCopy.NumFacebookLinkClicks += numFacebookLinkClicks;
        buyerStatsCopy.NumTwitterLinkClicks += numTwitterLinkClicks;
        buyerStatsCopy.NumLinkedInLinkClicks += numLinkedInLinkClicks;
        buyerStatsCopy.NumInstagramLinkClicks += numInstagramLinkClicks;
        buyerStatsCopy.NumEmailLinkClicks += numEmailLinkClicks;
        buyerStatsCopy.NumPinterestLinkClicks += numPinterestLinkClicks;
        buyerStatsCopy.NumWebLinkClicks += numWebLinkClicks;
        buyerStatsCopy.NumYouTubeLinkClicks += numYouTubeLinkClicks;

        stateCopy['BuyerStats'] = buyerStatsCopy;
        this.setState(stateCopy);

    }
    reload = () => {
        // we need to get the list of qrcodes for the provided buyer.
        QRQinectAPI.getBuyerStats(this.props.token)
            .then((response) => {
                // if they have no personal cards, but do have a business account; redirect them to the business account
                if (response.data.HasBusinessAccount && !response.data.QRCodeStats) {
                    this.props.history.push("/createCodes/" + this.props.token);
                }

                // update the dates in the Codes object (so we can filter on them)
                if (response.data.QRCodeStats) {
                    for (let i = 0; i < response.data.QRCodeStats.length; i++) {
                        response.data.QRCodeStats[i].UploadDateFormatted = this.formatDate(response.data.QRCodeStats[i].UploadDate);
                        response.data.QRCodeStats[i].LastScanFormatted = this.formatDate(response.data.QRCodeStats[i].LastScan);

                        // convert the notification data into an array we can update later
                        this.qrNotifyArray[response.data.QRCodeStats[i].QRCodeGUID + ''] = response.data.QRCodeStats[i].QRNotify;
                        this.qrStatsArray[response.data.QRCodeStats[i].QRCodeGUID + ''] = response.data.QRCodeStats[i].IncludeInStatistics;
                    }
                }

                this.setState({ Buyer: response.data.Buyer, BuyerStats: response.data.BuyerStats, Codes: response.data.QRCodeStats, ViewableCodes: response.data.QRCodeStats, showMessageDialog: false, message: null });
                this.Buyer = response.data.Buyer;

                // now that we have the buyer, let's get some preference values
                QRQinectAPI.Preference.getPreferencesByGroup("Buyer", this.Buyer.ID, QRQinectAPI.PreferenceGroup.Constants.MY_ACCOUNT)
                    .then((response) => {
                        this.setState({ ShowSendText: response.data[QRQinectAPI.Preference.Constants.SHOW_SEND_SMS_TO_CONTACT].Value, SendTextMessage: response.data[QRQinectAPI.Preference.Constants.SEND_SMS_TO_CONTACT_MESSAGE].Value });
                    });

                this.setState({ hasBusinessAccount: response.data.HasBusinessAccount, qrNotifyArray: this.qrNotifyArray, qrStatsArray: this.qrStatsArray, ShowComponent: true, loading: false });
                // this.getQRCodeStats();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ ShowComponent: true, error: true, errorMessage1: "It looks like you are trying to use an invalid or expired link to view your account.", errorMessage2: "Would you like us to send you an updated link?", showEmailButton: true, loading: false })
            });
    }
    // get the stats for each QRCode in state.Codes
    getQRCodeStats = () => {
        for (let i = 0; i < this.state.Codes.length; i++) {
            QRQinectAPI.getQRCodeStats(this.props.token, this.state.Codes[i].QRCodeGUID)
                .then((response) => {
                    response.data.QRCodeStats[0].UploadDateFormatted = this.formatDate(response.data.QRCodeStats[0].UploadDate);
                    response.data.QRCodeStats[0].LastScanFormatted = this.formatDate(response.data.QRCodeStats[0].LastScan);
                    this.setState({ StatsLoading: true, StatsProcessing: i + 1 });

                    // update stats for this code
                    this.updateCodeStats(i, response.data.QRCodeStats[0]);
                    // update the stats for the buyer
                    this.addQRtoBuyerStats(response.data.QRCodeStats[0]);
                    if (i === this.state.Codes.length - 1) {
                        this.setState({ StatsLoading: false });
                        // this.updateBuyerStats();
                    }
                })
        }
    }
    formatDate = (dateString) => {
        if (dateString === "0") {
            return "n/a";
        }
        let formattedDate = new Date(dateString.replace(/\s/, 'T') + "Z"); // replace is needed here for safari, https://stackoverflow.com/questions/21883699/safari-javascript-date-nan-issue-yyyy-mm-dd-hhmmss
        let hour = formattedDate.getHours();
        let period = 'am';
        if (hour === 12) {
            period = 'pm';
        } else if (hour > 12) {
            hour -= 12;
            period = 'pm';
        }
        let minutes = formattedDate.getMinutes();
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        return this.monthArray[formattedDate.getMonth()] + ' ' + formattedDate.getDate() + ' ' + formattedDate.getFullYear() + ' ' + hour + ':' + minutes + ' ' + period;
    }
    cancelHandler = () => {
        this.setState({ selectedQRCodeGUID: null, showModalDialog: false, showRenameDialog: false, showSearchModal: false, showSortModal: false, showSMSOptionsModal: false });
    }

    // not ideal, doesn't search viewable information, just data. Won't include dates properly, etc.
    searchQRCodes = () => {
        let tmpArray = [], i, key;
        for (i = 0; i < this.state.Codes.length; i++) {
            for (key in this.state.Codes[i]) {
                if ((this.state.Codes[i][key] + '').toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1) {
                    tmpArray.push(this.state.Codes[i]);
                }
            }
        }
        this.setState({ ViewableCodes: tmpArray, showSearchModal: false });
    }
    sortQRCodes = (type) => {
        switch (type) {
            case "name":
                this.sortedBy = "Name";
                this.setState({ ViewableCodes: this.state.ViewableCodes.sort((a, b) => { return ('' + a.NickName).localeCompare(b.NickName); }) });
                break;
            case "upload":
                this.sortedBy = "Added";
                this.setState({ ViewableCodes: this.state.ViewableCodes.sort((a, b) => { return ('' + b.UploadDate).localeCompare(a.UploadDate); }) });
                break;
            case "scan":
                this.sortedBy = "Viewed";
                this.setState({ ViewableCodes: this.state.ViewableCodes.sort((a, b) => { return ('' + b.LastScan).localeCompare(a.LastScan); }) });
                break;
            default:
                this.sortedBy = "";
                this.setState({ ViewableCodes: this.state.ViewableCodes });
                break;
        }
        this.setState({ showSortModal: false });
    }
    renameCard = () => {
        this.setState({ showRenameDialog: false });
        QRQinectAPI.updateQRCodeName(this.state.selectedQRCodeGUID, this.newName)
            .then((response) => {
                this.setState({ showMessageDialog: true, message: "Your Say More Card has been successfully renamed." });
            })
            .catch((error) => {
                console.log("error");
                console.log(error);
            });
    }
    handleNameChange(event) {
        this.newName = event.target.value;
    }
    handleSearchTermChange(event) {
        this.searchTerm = event.target.value;
    }
    resetCard = () => {
        this.setState({ showModalDialog: false });
        QRQinectAPI.resetQRCode(this.props.token, this.state.selectedQRCodeGUID)
            .then((response) => {
                this.setState({ showMessageDialog: true, message: "Your Say More Card has been successfully reset to factory settings." });
            })
            .catch((error) => {
                console.log("error");
                console.log(error);
            });
    }
    sendAccountLink = () => {
        // make sure the 'token' looks like an email address
        if ((/^.+@.+\..+$/.test(this.props.token))) {
            QRQinectAPI.sendBuyerAccountEmail(this.props.token)
                // axios.get(API_URL + 'api/v1/sendBuyerAccountEmail', {
                //     params: {
                //         email: this.props.token
                //     }
                // })
                .then((response) => {
                    this.setState({ errorMessage1: "An email has been sent to '" + this.props.token + "'", errorMessage2: "", showEmailButton: false });
                })
                .catch((error) => {
                    this.setState({ errorMessage1: "There was an error sending your email", errorMessage2: "Would you like to try again?" });
                    console.log(error);
                });
        } else {
            this.setState({ errorMessage1: "It looks like your email address is invalid", errorMessage2: "", showEmailButton: false });
        }
    }
    sendSMS(phone, qrGUID) {
        if (phone === "" && this.requirePhone) {
            phone = "CHOOSE CONTACT";
        }
        window.location.href = "sms:" + phone + this.SMSSeparator + "body=" + encodeURIComponent(this.state.CurrentSMSMessage);
    }
    sendAutomatedSMS() {
        QRQinectAPI.sendSMSToContact(this.props.token, this.state.CurrentSMSQRGUID, this.Buyer.ID, this.state.CurrentContactID, QRQinectAPI.SMSType.Constants.MANUAL_SCAN_REMINDER, this.state.CurrentSMSPhone, this.state.CurrentSMSMessage)
            .then((response) => {
                this.setState({ showSMSOptionsModal: false, showMessageDialog: true, message: "Your message has been sent" });
            })
            .catch((error) => {
                this.setState({ showSMSOptionsModal: false, showMessageDialog: true, message: "The following error occured when sending your message: " + error.toString() });
            });
    }
    reloadHandler = () => {
        this.setState({ showMessageDialog: false });
        this.reload();
    }
    updateNotificationState = (newValue, event, qrGUID) => {
        this.qrNotifyArray[qrGUID] = newValue;
        this.setState({ qrNotifyArray: this.qrNotifyArray });
        QRQinectAPI.updateSendScanNotifications(this.props.token, qrGUID, newValue)

            .catch((error) => {
                this.qrNotifyArray[qrGUID] = !newValue;
                this.setState({ qrNotifyArray: this.qrNotifyArray });
                console.log(error);
            });
    }
    updateIncludeInStatisticsState = (newValue, event, qrGUID) => {
        this.qrStatsArray[qrGUID] = newValue;
        this.setState({ qrStatsArray: this.qrStatsArray });
        QRQinectAPI.updateIncludeInStatistics(this.props.token, qrGUID, newValue)
            .then((response) => {
                this.reload();
            })
            .catch((error) => {
                this.qrStatsArray[qrGUID] = !newValue;
                this.setState({ qrStatsArray: this.qrStatsArray });
                console.log(error);
            });
    }
    renderQRShowStatistics = (card) => {
        return (
            <div>
                <label htmlFor={card.QRCodeGUID}>
                    <span>Include in Overall Statistics:</span>
                    <Switch
                        onChange={this.updateIncludeInStatisticsState}
                        checked={this.qrStatsArray[card.QRCodeGUID]}
                        className="react-switch"
                        id={card.QRCodeGUID}
                        height={this.state.Switch.height}
                        width={this.state.Switch.width}
                        onColor={this.state.Switch.primaryColor}
                    />
                </label>
            </div>
        );
    }
    renderQRNotification = (card) => {
        // don't show anything if the buyer doesn't want notifications
        if (!this.state.Buyer.SendScanNotifications) {
            return null;
        }
        // does this card allow notifications?
        if (card.CampaignNotify) {
            return (
                <React.Fragment>
                    <label htmlFor={card.QRCodeGUID}>
                        <span>Notifiy Me When Viewed:</span>
                        <Switch
                            onChange={this.updateNotificationState}
                            checked={this.qrNotifyArray[card.QRCodeGUID]}
                            className="react-switch"
                            id={card.QRCodeGUID}
                            height={this.state.Switch.height}
                            width={this.state.Switch.width}
                            onColor={this.state.Switch.primaryColor}
                        />
                    </label>
                </React.Fragment>
            );
        } else {
            return (
                <div>This card does not allow notifications</div>
            );
        }
    }
    renderQRClickStats = (row) => {
        if (this.state.ShowAllClickStats) {
            return (
                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-around", width: "100%" }}>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-rocket"></i></span><div style={{ textAlign: "center" }}>CTA: <span style={{ fontWeight: 'bold' }}>{row.CTAClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-facebook"></i><i className="fa fa-share-alt hide"></i></span><div style={{ textAlign: "center" }}>Shares: <span style={{ fontWeight: 'bold' }}>{row.FacebookShareClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-twitter"></i><i className="fa fa-share-alt hide"></i></span><div style={{ textAlign: "center" }}>Shares: <span style={{ fontWeight: 'bold' }}>{row.TwitterShareClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-linkedin"></i><i className="fa fa-share-alt hide"></i></span><div style={{ textAlign: "center" }}>Shares <span style={{ fontWeight: 'bold' }}>{row.LinkedInShareClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-envelope"></i><i className="fa fa-share-alt hide"></i></span><div style={{ textAlign: "center" }}>Shares: <span style={{ fontWeight: 'bold' }}>{row.EmailShareClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-facebook"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{row.FacebookLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-twitter"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{row.TwitterLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-linkedin"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{row.LinkedInLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-envelope"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{row.EmailLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-instagram"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{row.InstagramLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-pinterest"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{row.PinterestLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-globe"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{row.WebLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-youtube"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{row.YouTubeLinkClicks}</span></div></span>
                </div>
            );
        }
        return null;
    }
    renderCodes = () => {
        if (this.state.error) {
            return (
                <div style={{ textAlign: 'center' }}>
                    <p>{this.state.errorMessage1}</p>
                    <p>{this.state.errorMessage2}</p>
                    <button style={{ display: this.state.showEmailButton ? "block" : "none" }} className="button" onClick={this.sendAccountLink}>SEND NEW LINK</button>
                </div>
            );
        } else if (this.state.ViewableCodes) {
            return (
                <div className="font_regular">
                    {this.state.ViewableCodes.map((row, idx) => {
                        return (
                            <React.Fragment key={idx}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                                    <div style={{ width: '100%' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                            <span>
                                                <div><span className="font_medium">Name:</span> {row.NickName} <span style={{ cursor: 'pointer' }} className="fa fa-edit" onClick={() => { this.newName = row.NickName; this.setState({ selectedQRCodeGUID: row.QRCodeGUID, selectedQRCodeName: row.NickName, showRenameDialog: true }) }}></span></div>
                                                <div><span className="font_medium">Reference ID:</span> {row.QRCodeGUID}</div>
                                                <div><span className="font_medium">Uploaded:</span> {row.UploadDateFormatted}</div>
                                            </span>
                                            <span style={{ width: "63px", height: "63px", background: "center/contain no-repeat url(" + row.Thumbnail + ")" }}></span>
                                        </div>
                                        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-around", width: "100%" }}>
                                            <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-eye"></i></span><div style={{ textAlign: "center" }}>Views: <span style={{ fontWeight: 'bold' }}>{row.Scans}</span></div></span>
                                            <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-comment-o"></i></span><div style={{ textAlign: "center" }}>Messages: <span style={{ fontWeight: 'bold' }}>{row.Messages}</span></div></span>
                                            <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-download"></i></span><div style={{ textAlign: "center" }}>Downloads: <span style={{ fontWeight: 'bold' }}>{row.Downloads}</span></div></span>
                                            <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-hand-pointer-o"></i></span><div style={{ textAlign: "center" }}>Clicks: <span style={{ fontWeight: 'bold' }}>{row.Clicks}</span></div></span>
                                        </div>
                                        {this.renderQRClickStats(row)}
                                        {this.renderQRShowStatistics(row)}
                                        <div><span className="font_medium">Last Viewed:</span> {row.LastScanFormatted}</div>
                                        {this.renderQRNotification(row)}
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around", width: "100%" }}>
                                            <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><a style={{ fontSize: 'xx-large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" href={"/scan/" + row.QRCodeGUID + "/view"}><i className="fa fa-play-circle-o"></i></a><div style={{ textAlign: "center" }}>View Message</div></span>
                                            <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><a style={{ fontSize: 'xx-large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" href={"/scan/" + row.QRCodeGUID + "/video/" + this.props.token}><i className="fa fa-clone"></i></a><div style={{ textAlign: "center" }}>Replace Message</div></span>
                                            {this.renderResetCode(row)}
                                            {this.renderSendMessage(row)}
                                            {this.renderCustomizeWebEx(row)}
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </React.Fragment>
                        );
                    })}
                </div>
            );
        }
        return null;
    }
    prepSendSMS(row) {
        // get the text
        this.setState({ loading: true });
        QRQinectAPI.getReplacementText(row.QRCodeGUID, this.state.SendTextMessage)
            .then(response => {
                this.setState({ CurrentSMSMessage: response.data, loading: false });
                if (row.ContactPhoneE164 === "") {
                    this.sendSMS("", row.QRCodeGUID);
                } else {
                    this.setState({ showSMSOptionsModal: true, CurrentSMSQRGUID: row.QRCodeGUID, CurrentContactID: row.ContactID, CurrentSMSPhone: row.ContactPhoneE164 });
                }
            });
    }
    renderSendMessage(row) {
        // TODO: check if this campaign allows this
        // TODO: check if the campaign has specific text to send
        // TODO: might as well just pre-populate the href for the a here with "sms:PHONE(;?&)body=LINK"
        // TODO: propably scratch that last one, we'll probaly want to log when users use this...
        if (this.state.ShowSendText) {
            return (
                <React.Fragment>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><a style={{ fontSize: 'xx-large', margin: '0 auto', color: this.state.Switch.primaryColor, cursor: 'pointer' }} onClick={() => this.prepSendSMS(row)}><i className="fa fa-comment"></i></a><div style={{ textAlign: "center" }}>Send Text</div></span>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderResetCode(row) {
        if (!row.AllowCustomizeWebEx) {
            return (
                <React.Fragment>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><a style={{ fontSize: 'xx-large', margin: '0 auto', color: this.state.Switch.primaryColor, cursor: 'pointer' }} onClick={() => this.setState({ selectedQRCodeGUID: row.QRCodeGUID, selectedQRCodeName: row.NickName, showModalDialog: true })}><i className="fa fa-recycle"></i></a><div style={{ textAlign: "center" }}>Reset Code</div></span>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderCustomizeWebEx(row) {
        if (row.AllowCustomizeWebEx) {
            return (
                <React.Fragment>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><a style={{ fontSize: 'xx-large', margin: '0 auto', color: this.state.Switch.primaryColor, cursor: 'pointer' }} target="_blank" href={"/scan/" + row.QRCodeGUID + "/customizeExperience/" + this.props.token}><i className="fa fa-window-maximize"></i></a><div style={{ textAlign: "center" }}>Web Ex.</div></span>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderSpinner() {
        if (this.state.loading) {
            return (
                <React.Fragment>
                    <div style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            <p>Loading...</p>
                        </div>
                        <div className="fa-3x" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            <i className="fa fa-circle-o-notch fa-spin"></i>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderSendSMSOptionsModal() {
        if (this.state.showSMSOptionsModal) {
            return (
                <React.Fragment>
                    <div onClick={this.cancelHandler} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            <p>Send Text Message</p>
                        </div>
                        <div>To: {this.state.CurrentSMSPhone}</div>
                        <div className="chatBubble">
                            <div id="message" style={{ border: 'none', outline: 'none', resize: 'none' }}>
                                {this.state.CurrentSMSMessage}
                            </div>
                            <div className="chatBubbleArrow"></div>
                        </div>
                        <div>
                            <span style={{ fontSize: 'smaller' }}>*Your message will be delivered from a phone number controlled by Say More™</span>
                        </div>

                        <div className="button" style={{ cusor: 'pointer' }} onClick={() => this.sendAutomatedSMS("name")}>Send it for me</div>
                        <div>Or you can customize the message by clicking the button below.<br />
                            <span style={{ fontSize: 'smaller' }}>*Your message will be delivered from your personal phone number</span></div>
                        <div className="button" style={{ cusor: 'pointer' }} onClick={() => this.sendSMS(this.state.CurrentSMSPhone, this.state.CurrentSMSQRGUID)}>I'll send it myself</div>
                        <div>
                            <a className="button" onClick={this.cancelHandler} style={{ display: 'inline-block', backgroundColor: '#666' }}>CANCEL</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderSortModal() {
        if (this.state.showSortModal) {
            return (
                <React.Fragment>
                    <div onClick={this.cancelHandler} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            <p>Sort By</p>
                        </div>
                        <div className="button" style={{ cusor: 'pointer' }} onClick={() => this.sortQRCodes("name")}>Name (A - Z)</div>
                        <div className="button" style={{ cusor: 'pointer' }} onClick={() => this.sortQRCodes("upload")}>Date Added (New - Old)</div>
                        <div className="button" style={{ cusor: 'pointer' }} onClick={() => this.sortQRCodes("scan")}>Last Scanned (New - Old)</div>
                        <div>
                            <a className="button" onClick={this.cancelHandler} style={{ display: 'inline-block', backgroundColor: '#666' }}>CANCEL</a>
                            {/* <a className="button" onClick={this.searchQRCodes} style={{ display: 'inline-block', width: '45%' }}>SUBMIT</a> */}
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderSearchModal() {
        if (this.state.showSearchModal) {
            return (
                <React.Fragment>
                    <div onClick={this.cancelHandler} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            <p>Search</p>
                        </div>
                        <div>
                            <input type="text" defaultValue={this.searchTerm} onChange={event => this.handleSearchTermChange(event)}></input>
                        </div>
                        <div>
                            <a className="button" onClick={this.cancelHandler} style={{ display: 'inline-block', width: '45%', marginRight: '10%', backgroundColor: '#666' }}>CANCEL</a>
                            <a className="button" onClick={this.searchQRCodes} style={{ display: 'inline-block', width: '45%' }}>SUBMIT</a>
                        </div>
                        <div>
                            <a onClick={() => { this.setState({ ViewableCodes: this.state.Codes, showSearchModal: false }); this.searchTerm = ""; }}>Clear Search and Show All Results</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderRenameModal() {
        if (this.state.showRenameDialog) {
            return (
                <React.Fragment>
                    <div onClick={this.cancelHandler} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            <p>Are you sure you want to rename '{this.state.selectedQRCodeName}'?</p>
                        </div>
                        <div>
                            <label>New Name: </label><input type="text" defaultValue={this.newName} onChange={event => this.handleNameChange(event)}></input>
                        </div>

                        <div>
                            <a className="button" onClick={this.cancelHandler} style={{ display: 'inline-block', width: '45%', marginRight: '10%', backgroundColor: '#666' }}>CANCEL</a>
                            <a className="button" onClick={this.renameCard} style={{ display: 'inline-block', width: '45%' }}>SUBMIT</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderResetModal() {
        if (this.state.showModalDialog) {
            return (
                <React.Fragment>
                    <div onClick={this.cancelHandler} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            <p>Are you sure you want to reset '{this.state.selectedQRCodeName}'?</p>
                        </div>
                        <div>
                            Resetting this Say More Card will return it back to its original state. This will remove your message, any views, etc.
                        </div>
                        <div>
                            It will be like it's never been touched before!
                        </div>
                        <div>
                            <a className="button" onClick={this.cancelHandler} style={{ display: 'inline-block', width: '45%', marginRight: '10%', backgroundColor: '#666' }}>BACK</a>
                            <a className="button" onClick={this.resetCard} style={{ display: 'inline-block', width: '45%' }}>RESET</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderMessageModal() {
        if (this.state.showMessageDialog) {
            return (
                <React.Fragment>
                    <div onClick={this.reload} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div>
                            {this.state.message}
                        </div>
                        <div>
                            <a className="button" onClick={this.reload} style={{ display: 'inline-block', backgroundColor: '#666' }}>BACK</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    updateBuyerNotificationState = (newState, event, id) => {
        this.Buyer.SendScanNotifications = newState;
        this.setState({ Buyer: this.Buyer });
        QRQinectAPI.updateScanNotifications(this.props.token, this.state.Buyer.ID, newState)
            // axios.get(API_URL + 'api/v1/updateSendScanNotifications', {
            //     headers: { "Authorization": this.props.token, "Content-Type": "application/x-www-form-urlencoded" },
            //     params: {
            //         Token: this.props.token,
            //         Type: "Buyer",
            //         ID: this.state.Buyer.ID,
            //         SendScanNotifications: newState
            //     }
            // })
            .catch((error) => {
                this.Buyer.SendScanNotifications = !newState;
                this.setState({ Buyer: this.Buyer });
                console.log(error);
            });
    }
    toggleShowAllClickStats = () => {
        this.setState({ ShowAllClickStats: !this.state.ShowAllClickStats });
    }
    renderOverallClickStats = () => {
        if (this.state.ShowAllClickStats) {
            return (
                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-around", width: "100%" }}>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-rocket"></i></span><div style={{ textAlign: "center" }}>CTA: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumCTAClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-facebook"></i><i className="fa fa-share-alt hide"></i></span><div style={{ textAlign: "center" }}>Shares: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumFacebookShareClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-twitter"></i><i className="fa fa-share-alt hide"></i></span><div style={{ textAlign: "center" }}>Shares: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumTwitterShareClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-linkedin"></i><i className="fa fa-share-alt hide"></i></span><div style={{ textAlign: "center" }}>Shares <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumLinkedInShareClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-envelope"></i><i className="fa fa-share-alt hide"></i></span><div style={{ textAlign: "center" }}>Shares: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumEmailShareClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-facebook"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumFacebookLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-twitter"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumTwitterLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-linkedin"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumLinkedInLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-envelope"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumEmailLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-instagram"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumInstagramLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-pinterest"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumPinterestLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-globe"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumWebLinkClicks}</span></div></span>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-youtube"></i><i className="fa fa-link hide"></i></span><div style={{ textAlign: "center" }}>Links: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumYouTubeLinkClicks}</span></div></span>
                </div>
            );
        }
        return null;
    }
    renderStatsLoading() {
        if (this.state.StatsLoading) {
            return (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around", width: "100%" }}>
                    <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-cog fa-spin fa-3x fa-fw"></i></span><div style={{ textAlign: "center" }}><span style={{ fontWeight: 'bold' }}>Processing {this.state.StatsProcessing} of {this.state.BuyerStats.NumCodes}</span></div></span>
                </div>
            );
        }
        return null;
    }
    renderBuyerOverallStats() {
        if (this.state.BuyerStats) {
            return (
                <React.Fragment>
                    {this.renderStatsLoading()}
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around", width: "100%" }}>
                        <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-envelope-open"></i></span><div style={{ textAlign: "center" }}>Cards: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumCodes}</span></div></span>
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-around", width: "100%" }}>
                        <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-eye"></i></span><div style={{ textAlign: "center" }}>Views: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumScans}</span><br />Rate: <span style={{ fontWeight: 'bold' }}>{Math.ceil((this.state.BuyerStats.NumCodesWithScans / Math.max(this.state.BuyerStats.NumCodes, 1)) * 100)}%</span></div></span>
                        <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-comment-o"></i></span><div style={{ textAlign: "center" }}>Messages: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumMessages}</span><br />Rate: <span style={{ fontWeight: 'bold' }}>{Math.ceil((this.state.BuyerStats.NumCodesWithMessages / Math.max(this.state.BuyerStats.NumCodes, 1)) * 100)}%</span></div></span>
                        <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-download"></i></span><div style={{ textAlign: "center" }}>Downloads: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumDownloads}</span><br />Rate: <span style={{ fontWeight: 'bold' }}>{Math.ceil((this.state.BuyerStats.NumCodesWithDownloads / Math.max(this.state.BuyerStats.NumCodes, 1)) * 100)}%</span></div></span>
                        <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-hand-pointer-o"></i></span><div style={{ textAlign: "center" }}>Clicks: <span style={{ fontWeight: 'bold' }}>{this.state.BuyerStats.NumClicks}</span><br />Rate: <span style={{ fontWeight: 'bold' }}>{Math.ceil((this.state.BuyerStats.NumCodesWithClicks / Math.max(this.state.BuyerStats.NumCodes, 1)) * 100)}%</span></div></span>
                    </div>
                    {this.renderOverallClickStats()}
                    <hr />
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderShowAllClicksToggle = () => {
        return (
            <React.Fragment>
                <label htmlFor="ShowAllClicksToggle">
                    <span>Show Advanced Statistics:</span>
                    <Switch
                        onChange={this.toggleShowAllClickStats}
                        checked={this.state.ShowAllClickStats}
                        className="react-switch"
                        id="ShowAllClicksToggle"
                        height={this.state.Switch.height}
                        width={this.state.Switch.width}
                        onColor={this.state.Switch.primaryColor}
                    />
                </label>
            </React.Fragment>
        );
    }
    renderBuyerNotificationOptions() {
        return (
            <React.Fragment>
                <label htmlFor={this.state.Buyer.Email}>
                    <span>Allow notifications when someone views my cards:</span>
                    <Switch
                        onChange={this.updateBuyerNotificationState}
                        checked={this.Buyer.SendScanNotifications}
                        className="react-switch"
                        id={this.state.Buyer.Email}
                        height={this.state.Switch.height}
                        width={this.state.Switch.width}
                        onColor={this.state.Switch.primaryColor}
                    />
                </label>
            </React.Fragment>
        );
    }
    renderAddCodeButton = () => {
        return (
            <div>
                <a className="button" href={"/?token=" + this.props.token}>ADD A CODE</a>
            </div>
        );
    }
    renderBusinessAccountButton = () => {
        if (this.state.hasBusinessAccount) {
            return (
                <div>
                    <a className="button" onClick={() => { this.props.history.push("/createCodes/" + this.props.token) }}>VIEW DISTRIBUTOR ACCOUNT</a>
                </div>
            );
        }
    }
    renderHeader = () => {
        return (
            <React.Fragment>
                <div style={{ textAlign: 'center' }}>
                    <div>{this.state.Buyer.Name}</div>
                    <div style={{ textAlign: 'center' }}>
                        <a onClick={() => this.props.history.push('/accountPassword/update/' + this.props.token)}>Change Password</a>
                    </div>
                    {this.renderBusinessAccountButton()}
                    {this.renderAddCodeButton()}
                    {this.renderBuyerNotificationOptions()}
                    <p>Your viewing statistics</p>
                    {this.renderBuyerOverallStats()}
                </div>
            </React.Fragment>
        );
    }
    renderViewingOptions = () => {
        return (
            <React.Fragment>
                <div style={{ textAlign: 'center' }}>
                    <div>*Viewing Options:</div>
                    {this.renderShowAllClicksToggle()}
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around", width: "100%" }}>
                        <span onClick={() => this.setState({ showSearchModal: true })} style={{ cursor: "pointer", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-search"></i></span><span> Search {this.searchTerm !== "" ? "(" + this.searchTerm + ")" : ""}</span></span>
                        <span onClick={() => this.setState({ showSortModal: true })} style={{ cursor: "pointer", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-sort-alpha-asc"></i></span><span> Sort {this.sortedBy !== "" ? "(" + this.sortedBy + ")" : ""}</span></span>

                        {/* <span onClick={() => this.sortQRCodes("name")} style={{ width: '75px', cursor: "pointer", display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-sort-alpha-asc"></i></span><div style={{ textAlign: "center" }}>Name<br/>(A-Z)</div></span>
                                        <span onClick={() => this.sortQRCodes("upload")} style={{ width: '75px', cursor: "pointer", display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-sort-numeric-desc"></i></span><div style={{ textAlign: "center" }}>Age<br/>(New-Old)</div></span>
                                        <span onClick={() => this.sortQRCodes("scan")} style={{ width: '75px', cursor: "pointer", display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-sort-numeric-desc"></i></span><div style={{ textAlign: "center" }}>Viewed<br/>(New-Old)</div></span> */}
                    </div>
                    <div style={{ fontSize: 'smaller', paddingTop: '5px' }}>*Overall viewing statistics will not be affected by filters.</div>
                </div>
                <hr />
            </React.Fragment>
        );
    }
    renderBody = () => {
        return (
            <React.Fragment>
                {this.renderViewingOptions()}
                {this.renderCodes()}
            </React.Fragment>
        );
    }
    render() {
        if (!this.state.ShowComponent) {
            if (this.state.loading) {
                return (
                    <React.Fragment>
                        {this.renderSpinner()}
                    </React.Fragment>
                );
            }
            return null;
        }
        return (
            <React.Fragment>
                <div className="login_register">
                    <div className="container">
                        <div className="entry">
                            <div className="head">
                                <div className="logoImage"></div>
                                {this.renderHeader()}
                                {this.renderBody()}
                            </div>
                        </div>
                    </div>
                </div>

                {this.renderResetModal()}
                {this.renderRenameModal()}
                {this.renderSearchModal()}
                {this.renderSortModal()}
                {this.renderMessageModal()}
                {this.renderSendSMSOptionsModal()}
                {this.renderSpinner()}
            </React.Fragment>
        );
    }
}
export default withRouter(MyCodes);


// WEBPACK FOOTER //
// ./src/components/MyCodes.js